import NProgress from 'nprogress';

NProgress.configure({
  showSpinner: false,
  minimum: 0.15,
  trickleSpeed: 300,
});
